import { render, staticRenderFns } from "./AdminSupportDetailsContainer.vue?vue&type=template&id=52acf29b&scoped=true"
import script from "./AdminSupportDetailsContainer.vue?vue&type=script&lang=js"
export * from "./AdminSupportDetailsContainer.vue?vue&type=script&lang=js"
import style0 from "./AdminSupportDetailsContainer.vue?vue&type=style&index=0&id=52acf29b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52acf29b",
  null
  
)

export default component.exports